@if (!loading()) {
  <div
    [formGroup]="appointmentForm"
    class="flex flex-col"
  >
    <mat-form-field class="w-full">
      <mat-label>Місто</mat-label>
      <input
        matInput
        type="text"
        [formControlName]="appointmentControlsNames.City"
        [matAutocomplete]="cityAutocomplete"
      />
      <mat-autocomplete #cityAutocomplete="matAutocomplete">
        @for (city of filteredCitiesOptions(); track city) {
          <mat-option [value]="city">
            {{ city }}
          </mat-option>
        }
      </mat-autocomplete>
      @if (fc[appointmentControlsNames.City].invalid && fc[appointmentControlsNames.City].touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Партнер</mat-label>
      <mat-select [formControlName]="appointmentControlsNames.PartnerName">
        @for (partner of allPartnersOptions(); track partner.id) {
          <mat-option
            [value]="partner.shortName"
            (click)="selectPartnerOption(partner.id)"
          >
            {{ partner.shortName }}
            @if (partner.legalEntity) {
              <span>({{ partner.legalEntity.name }})</span>
            }
          </mat-option>
        }
      </mat-select>
      @if (fc[appointmentControlsNames.PartnerName].invalid && fc[appointmentControlsNames.PartnerName].touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Адреса надання послуги</mat-label>
      <mat-select [formControlName]="appointmentControlsNames.Location">
        @for (location of allLocationsOptions(); track location.id) {
          <mat-option
            [value]="location.address"
            (click)="selectLocationOption(location.id)"
          >
            {{ location.name }} ({{ location.address }})
          </mat-option>
        }
      </mat-select>
      @if (fc[appointmentControlsNames.Location].invalid && fc[appointmentControlsNames.Location].touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>Вартість послуги (грн)</mat-label>
      <input
        matInput
        type="number"
        min="0"
        step="0.01"
        [formControlName]="appointmentControlsNames.Price"
      />
      @if (fc[appointmentControlsNames.Price].invalid && fc[appointmentControlsNames.Price].touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="w-full">
      <mat-label>ПІБ лікаря</mat-label>
      <input
        matInput
        type="text"
        [formControlName]="appointmentControlsNames.DoctorName"
      />
      @if (fc[appointmentControlsNames.DoctorName].invalid && fc[appointmentControlsNames.DoctorName].touched) {
        <mat-error>Це обов'язкове поле</mat-error>
      }
    </mat-form-field>

    <div class="flex w-full gap-4">
      <mat-form-field class="flex-1">
        <mat-label>Дата візиту</mat-label>
        <input
          matInput
          [formControlName]="appointmentControlsNames.DateStart"
          [matDatepicker]="datePicker"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="datePicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
        @if (fc[appointmentControlsNames.DateStart].invalid && fc[appointmentControlsNames.DateStart].touched) {
          <mat-error>Це обов'язкове поле</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-1">
        <mat-label>Час візиту</mat-label>
        <input
          matInput
          type="time"
          [formControlName]="appointmentControlsNames.Time"
        />
        @if (fc[appointmentControlsNames.Time].invalid && fc[appointmentControlsNames.Time].touched) {
          <mat-error>Це обов'язкове поле</mat-error>
        }
      </mat-form-field>
    </div>

    <div class="w-full pb-1">
      <mat-checkbox [formControlName]="appointmentControlsNames.AppointmentCompletedFlag"> Візит завершено </mat-checkbox>
    </div>
  </div>
} @else {
  <div class="flex items-center justify-center">
    <shared-loader></shared-loader>
  </div>
}
